import { formatDate, formatQuantity } from '@/features/warehouse/format';
import type { Receipt, ReceiptItem } from '@/features/warehouse/types';

/** Значение ячейки журнала приёмки: суффикс поля (journals.field.*) → текст. */
export type ReceiptRowValues = Record<string, string>;

/**
 * Строка бракеражного журнала из одной строки накладной. Всё, что бэкенд
 * знает о партии, журнал получает готовым; дата фактической реализации и
 * подпись ответственного остаются под руку и печатаются пустыми.
 */
export function receiptRowValues(receipt: Receipt, item: ReceiptItem): ReceiptRowValues {
  const expiry = item.expiryDate ? `до ${formatDate(item.expiryDate)}` : '';
  const storage = [item.storageConditions, expiry].filter(Boolean).join('; ');

  return {
    arrivalDateTime: formatDate(receipt.date),
    productName: item.productName,
    packaging: item.packaging,
    productionDate: formatDate(item.productionDate),
    manufacturer: item.manufacturer,
    supplier: item.supplier,
    arrivalQuantity: formatQuantity(item.quantity, item.unit),
    safetyDocument: item.documentNumber || item.documentType,
    organoleptic: item.organoleptic,
    storageConditions: storage,
    note: item.note,
    // Журнал контроля поступления сырья (ЖУРН-03).
    date: formatDate(receipt.date),
    product: item.productName,
    quantity: formatQuantity(item.quantity, item.unit),
    shelfLife: item.expiryDate ? `до ${formatDate(item.expiryDate)}` : '',
    condition: item.organoleptic,
  };
}

/** Документ попал в период печати журнала: [from..to] включительно, гггг-мм-дд. */
export function receiptInPeriod(date: string, from: string, to: string): boolean {
  return date >= from && date <= to;
}

/** Накладные в журнал идут по возрастанию даты — так их и подписывают. */
export function byReceiptDate(a: Receipt, b: Receipt): number {
  return a.date.localeCompare(b.date) || a.invoiceNumber.localeCompare(b.invoiceNumber);
}
